/* Admin Center — Activity Log tab (extracted from AdminPage.tsx) */

import { FirmActivityPanel } from '../../components/FirmActivityPanel';
import { rem } from '../../lib/rem';
import type { AdminPageProps } from './types';

/* ═══════════ ACTIVITY LOG TAB ═══════════
   Cross-user, server-side audit log of every meaningful firm action.
   Used by principals to spot dormant beta testers and watch usage.
   30-day retention; pruning runs in the background on EC2. */
function ActivityLogTab({ toast }: { toast: AdminPageProps['toast'] }) {
  return (
    <div>
      <div style={{ marginBottom: 'var(--space-4)' }}>
        <p style={{ fontSize: 'var(--font-size-base)', color: 'var(--tm)', margin: 0 }}>
          Server-side audit log of every meaningful action across the firm. 30-day retention. Use
          this to spot dormant beta testers and watch usage patterns.
        </p>
      </div>
      <FirmActivityPanel toast={toast} />
    </div>
  );
}

export { ActivityLogTab };
